export default "__VITE_ASSET__0a76db02__"